module.exports = __webpack_public_path__ + "static/media/ksa-flag.708659e1.svg";